import { render, staticRenderFns } from "./ManageDepartmentModal.vue?vue&type=template&id=a455a022&"
import script from "./ManageDepartmentModal.vue?vue&type=script&lang=js&"
export * from "./ManageDepartmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports